export default "/images/f86003b0d1d33800a88a92353a8ba0ab.avif";